export const EMPTY_LIST_CONFIG = [
  {
    entity: {
      id: 0,
      name: "",
    },
    events: [],
  },
]
